<template>
    <div class="base-card verification-shadow-card">
        <div class="lines">
            <div class="line short"></div>
            <div class="divider"></div>
            <div class="line medium"></div>
            <div class="line long"></div>
            <div class="line long"></div>
            <div class="line short"></div>
            <div class="line medium"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ShadowItem'
}
</script>
